/* ============================================
   SIDEBAR COMPONENT - Dashboard Navigation
   ============================================ */

import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function Sidebar() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/', { replace: true });
  };

  return (
    <aside className="sidebar">
      <div className="sidebar-brand">
        <img
          src="https://i.ibb.co/dskBFvr8/cpanel-new-large.webp"
          alt="cPanel"
          className="sidebar-logo"
          draggable={false}
          onContextMenu={(e) => e.preventDefault()}
        />
        <span className="sidebar-title">Admin</span>
      </div>

      <div className="sidebar-user">
        <div className="user-avatar">
          {user?.avatar ? (
            <img src={user.avatar} alt="avatar" />
          ) : (
            <span className="avatar-fallback">
              {(user?.displayName || user?.username || 'A').charAt(0).toUpperCase()}
            </span>
          )}
        </div>
        <div className="user-info">
          <p className="user-name">{user?.displayName || user?.username}</p>
          <p className="user-role">{user?.role}</p>
        </div>
      </div>

      <nav className="sidebar-nav">
        <NavLink to="/dashboard/home" className={({ isActive }) => (isActive ? 'nav-link active' : 'nav-link')}>
          <svg className="nav-icon" viewBox="0 0 24 24" fill="currentColor">
            <path d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z" />
          </svg>
          Home
        </NavLink>
        <NavLink to="/dashboard/account" className={({ isActive }) => (isActive ? 'nav-link active' : 'nav-link')}>
          <svg className="nav-icon" viewBox="0 0 24 24" fill="currentColor">
            <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z" />
          </svg>
          Account
        </NavLink>
      </nav>

      <div className="sidebar-footer">
        <button className="logout-btn" onClick={handleLogout}>
          <svg className="nav-icon" viewBox="0 0 24 24" fill="currentColor">
            <path d="M17 7l-1.41 1.41L18.17 11H8v2h10.17l-2.58 2.58L17 17l5-5zM4 5h8V3H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h8v-2H4V5z" />
          </svg>
          Log Out
        </button>
      </div>

      <style>{`
        .sidebar {
          width: 240px;
          background: #1e1e1e;
          border-right: 1px solid #333;
          display: flex;
          flex-direction: column;
          min-height: 100vh;
          position: fixed;
          left: 0;
          top: 0;
          bottom: 0;
          z-index: 100;
        }
        .sidebar-brand {
          display: flex;
          align-items: center;
          gap: 10px;
          padding: 20px;
          border-bottom: 1px solid #333;
        }
        .sidebar-logo {
          width: 90px;
          height: auto;
          user-select: none;
          -webkit-user-drag: none;
          pointer-events: none;
        }
        .sidebar-title {
          color: #ff6c2c;
          font-weight: bold;
          font-size: 14px;
          letter-spacing: 1px;
        }
        .sidebar-user {
          display: flex;
          align-items: center;
          gap: 12px;
          padding: 20px;
          border-bottom: 1px solid #333;
        }
        .user-avatar {
          width: 44px;
          height: 44px;
          border-radius: 50%;
          background: linear-gradient(135deg, #ff6c2c, #e05216);
          display: flex;
          align-items: center;
          justify-content: center;
          color: #fff;
          font-weight: bold;
          font-size: 18px;
          overflow: hidden;
          flex-shrink: 0;
        }
        .user-avatar img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
        .user-info {
          overflow: hidden;
        }
        .user-name {
          color: #fff;
          font-size: 13px;
          font-weight: bold;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .user-role {
          color: #888;
          font-size: 11px;
          text-transform: capitalize;
          margin-top: 2px;
        }
        .sidebar-nav {
          flex: 1;
          padding: 15px 0;
        }
        .nav-link {
          display: flex;
          align-items: center;
          gap: 12px;
          padding: 12px 20px;
          color: #aaa;
          text-decoration: none;
          font-size: 13px;
          transition: all 0.2s;
          border-left: 3px solid transparent;
        }
        .nav-link:hover {
          color: #fff;
          background: rgba(255, 255, 255, 0.03);
        }
        .nav-link.active {
          color: #ff6c2c;
          background: rgba(255, 108, 44, 0.08);
          border-left-color: #ff6c2c;
        }
        .nav-icon {
          width: 20px;
          height: 20px;
          flex-shrink: 0;
        }
        .sidebar-footer {
          padding: 15px;
          border-top: 1px solid #333;
        }
        .logout-btn {
          width: 100%;
          display: flex;
          align-items: center;
          gap: 12px;
          padding: 10px 12px;
          background: rgba(255, 255, 255, 0.05);
          border: 1px solid #444;
          border-radius: 4px;
          color: #ccc;
          font-size: 13px;
          cursor: pointer;
          transition: all 0.2s;
        }
        .logout-btn:hover {
          background: rgba(220, 50, 50, 0.15);
          border-color: #c33;
          color: #ff5555;
        }
        @media (max-width: 768px) {
          .sidebar {
            width: 200px;
          }
        }
      `}</style>
    </aside>
  );
}
